"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var R = _interopRequireWildcard(require("ramda"));
var _utils = require("@trs/utils");
var _config = require("@trs/config");
var _MediaCreator = _interopRequireDefault(require("./MediaCreator"));
var _MediaObject = _interopRequireDefault(require("./MediaObject"));
var _EditMenu = _interopRequireDefault(require("./EditMenu"));
var _icon = _interopRequireDefault(require("../icon"));
var _helpers = require("./helpers");
var _StyledBanner = require("./StyledBanner.style");
var _InputError = _interopRequireDefault(require("../errors/InputError"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var Banner = /*#__PURE__*/function (_Component) {
  _inherits(Banner, _Component);
  var _super = _createSuper(Banner);
  function Banner(props) {
    var _this;
    _classCallCheck(this, Banner);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "handleMediaCreatorPopup", function () {
      var handleDuringEdit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var _this$props = _this.props,
        disabled = _this$props.disabled,
        src = _this$props.src;
      var emptyBanner = R.isNil(src) || R.isEmpty(src);
      if ((emptyBanner || handleDuringEdit) && !disabled) {
        _this.setState(function (prevProps) {
          return {
            creatorOpen: !prevProps.creatorOpen
          };
        });
      }
    });
    _defineProperty(_assertThisInitialized(_this), "onMouseEnterHandler", function () {
      _this.setState({
        showMoreIcon: true
      });
    });
    _defineProperty(_assertThisInitialized(_this), "onMouseLeaveHandler", function () {
      _this.setState({
        showMoreIcon: false
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleMediaEditMenu", function () {
      _this.setState(function (prevProps) {
        return {
          editMenuOpen: !prevProps.editMenuOpen
        };
      });
    });
    _defineProperty(_assertThisInitialized(_this), "onEditLink", function () {
      _this.handleMediaEditMenu();
      _this.handleMediaCreatorPopup(true);
    });
    _defineProperty(_assertThisInitialized(_this), "onDeleteLink", function () {
      _this.handleMediaEditMenu();
      _this.props.onChange({
        src: '',
        alt: ''
      });
    });
    _this.state = {
      creatorOpen: false,
      showMoreIcon: false,
      editMenuOpen: false
    };
    return _this;
  }
  _createClass(Banner, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$state = this.state,
        creatorOpen = _this$state.creatorOpen,
        showMoreIcon = _this$state.showMoreIcon,
        editMenuOpen = _this$state.editMenuOpen;
      var _this$props2 = this.props,
        type = _this$props2.type,
        src = _this$props2.src,
        alt = _this$props2.alt,
        disabled = _this$props2.disabled,
        labels = _this$props2.labels,
        supportedMediaTypes = _this$props2.supportedMediaTypes,
        recommendedMediaSizes = _this$props2.recommendedMediaSizes,
        images = _this$props2.images,
        videoPlatformAccepted = _this$props2.videoPlatformAccepted,
        readOnly = _this$props2.readOnly,
        error = _this$props2.error;
      var mediaIcon = images.mediaIcon,
        disabledMediaIcon = images.disabledMediaIcon,
        badImageURL = images.badImageURL;
      var hasError = !(0, _utils.isBlank)(error);
      var emptyBanner = R.isNil(src) || R.isEmpty(src);
      return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement(_StyledBanner.StyledBanner, {
        readOnly: readOnly,
        onMouseEnter: this.onMouseEnterHandler,
        onMouseLeave: this.onMouseLeaveHandler
      }, !readOnly && /*#__PURE__*/_react["default"].createElement(_StyledBanner.StyledMediaHandler, {
        onClick: function onClick() {
          return _this2.handleMediaCreatorPopup(false);
        },
        className: (0, _classnames["default"])({
          disabled: !emptyBanner || disabled
        })
      }, /*#__PURE__*/_react["default"].createElement("img", {
        src: !emptyBanner || disabled ? disabledMediaIcon : mediaIcon,
        alt: "media",
        className: "media-helper-icon"
      }), /*#__PURE__*/_react["default"].createElement("p", {
        className: "helper-text"
      }, labels.ADD_MEDIA)), creatorOpen && /*#__PURE__*/_react["default"].createElement(_MediaCreator["default"], {
        componentName: _helpers.MEDIA_COMPONENTS.BANNER,
        supportedMediaTypes: supportedMediaTypes,
        onClose: function onClose() {
          return _this2.handleMediaCreatorPopup(true);
        },
        onChange: this.props.onChange,
        type: type,
        src: src,
        alt: alt,
        labels: labels,
        recommendedMediaSizes: recommendedMediaSizes,
        videoPlatformAccepted: videoPlatformAccepted
      }), hasError && /*#__PURE__*/_react["default"].createElement(_InputError["default"], {
        className: "rdw-inputError",
        message: error
      }), !R.isNil(src) && !R.isEmpty(src) && /*#__PURE__*/_react["default"].createElement(_StyledBanner.StyledMediaContainer, null, /*#__PURE__*/_react["default"].createElement(_StyledBanner.StyledMedia, null, showMoreIcon && !disabled && /*#__PURE__*/_react["default"].createElement(_icon["default"], {
        className: "more-icon icon-ion-android-more-vertical",
        size: 24,
        onClick: this.handleMediaEditMenu
      }), editMenuOpen && /*#__PURE__*/_react["default"].createElement(_EditMenu["default"], {
        onClose: this.handleMediaEditMenu,
        onEdit: this.onEditLink,
        onDelete: this.onDeleteLink
      }), /*#__PURE__*/_react["default"].createElement(_MediaObject["default"], {
        type: type,
        src: src,
        alt: alt,
        readOnly: readOnly,
        imageFallback: badImageURL,
        recommendedMediaSizes: recommendedMediaSizes[_helpers.MEDIA_COMPONENTS.BANNER]
      })))), !emptyBanner && readOnly && alt && /*#__PURE__*/_react["default"].createElement("p", {
        className: "media-object-title"
      }, alt));
    }
  }]);
  return Banner;
}(_react.Component);
Banner.defaultProps = {
  readOnly: false,
  recommendedMediaSizes: {},
  type: _config.MEDIA_TYPE.IMAGE,
  src: '',
  alt: '',
  videoPlatformAccepted: [],
  error: undefined
};
Banner.propTypes = {
  readOnly: _propTypes["default"].bool,
  type: _propTypes["default"].string,
  onChange: _propTypes["default"].func.isRequired,
  src: _propTypes["default"].string,
  alt: _propTypes["default"].string,
  disabled: _propTypes["default"].bool.isRequired,
  labels: _propTypes["default"].shape({
    ADD_MEDIA: _propTypes["default"].string
  }).isRequired,
  recommendedMediaSizes: _propTypes["default"].shape({}),
  supportedMediaTypes: _propTypes["default"].shape({}).isRequired,
  images: _propTypes["default"].shape({
    mediaIcon: _propTypes["default"].string,
    disabledMediaIcon: _propTypes["default"].string,
    badImageURL: _propTypes["default"].string
  }).isRequired,
  error: _propTypes["default"].string,
  videoPlatformAccepted: _propTypes["default"].arrayOf(_propTypes["default"].string)
};
Banner.__docgenInfo = {
  "description": "",
  "methods": [{
    "name": "handleMediaCreatorPopup",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "handleDuringEdit",
      "type": null
    }],
    "returns": null
  }, {
    "name": "onMouseEnterHandler",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "onMouseLeaveHandler",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "handleMediaEditMenu",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "onEditLink",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "onDeleteLink",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }],
  "displayName": "Banner",
  "props": {
    "readOnly": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "recommendedMediaSizes": {
      "defaultValue": {
        "value": "{}",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "shape",
        "value": {}
      },
      "required": false
    },
    "type": {
      "defaultValue": {
        "value": "MEDIA_TYPE.IMAGE",
        "computed": true
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "src": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "alt": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "videoPlatformAccepted": {
      "defaultValue": {
        "value": "[]",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "string"
        }
      },
      "required": false
    },
    "error": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "onChange": {
      "description": "",
      "type": {
        "name": "func"
      },
      "required": true
    },
    "disabled": {
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": true
    },
    "labels": {
      "description": "",
      "type": {
        "name": "shape",
        "value": {
          "ADD_MEDIA": {
            "name": "string",
            "required": false
          }
        }
      },
      "required": true
    },
    "supportedMediaTypes": {
      "description": "",
      "type": {
        "name": "shape",
        "value": {}
      },
      "required": true
    },
    "images": {
      "description": "",
      "type": {
        "name": "shape",
        "value": {
          "mediaIcon": {
            "name": "string",
            "required": false
          },
          "disabledMediaIcon": {
            "name": "string",
            "required": false
          },
          "badImageURL": {
            "name": "string",
            "required": false
          }
        }
      },
      "required": true
    }
  }
};
var _default = Banner;
exports["default"] = _default;